export const generateRandomID = () => Math.random().toString(36).slice(2)
